import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { useQuery } from "urql";

const ApiKeysQuery = graphql(`
  query GetApiKeys {
    apiKeys {
      id
      name
      prefixHint
      scopes
      createdBy
      createdAt
      lastUsedAt
      expiresAt
      revokedAt
    }
  }
`);

export function useApiKeys() {
  const [result, reexecuteQuery] = useQuery({
    query: ApiKeysQuery,
    requestPolicy: "cache-and-network",
  });

  const { data, fetching: isFetching, error } = result;
  const isPending = isFetching && !data;

  const apiKeys = useMemo(() => data?.apiKeys ?? [], [data]);

  const refetch = () => reexecuteQuery({ requestPolicy: "network-only" });

  return { apiKeys, isFetching, isPending, error, refetch };
}
